(() => {
  const TARGET_SELECTORS = [
    '[data-size-guide-target="simonis-860"]',
    '[data-size-guide-target="championship-invitational"]'
  ];
  const GUIDE_SELECTOR = '[data-size-guide]';
  const SIZE_OPTION_SELECTOR = '[data-simonis-size-option]';
  const ACTIVE_CLASS = 'is-visible';
  const FINISHED_CLASS = 'is-finished';
  const START_DELAY_MS = 300;
  const FINISH_DELAY_MS = 3500;

  if (window.__simonisSizeGuideBound) return;
  window.__simonisSizeGuideBound = true;

  let observer = null;
  let started = false;
  let finished = false;
  let showTimer = null;
  let hideTimer = null;
  const boundCards = new WeakSet();

  function getCards() {
    return TARGET_SELECTORS
      .map((selector) => document.querySelector(selector))
      .filter(Boolean);
  }

  function getGuides(cards = getCards()) {
    return cards
      .map((card) => card.querySelector(GUIDE_SELECTOR))
      .filter(Boolean);
  }

  function hideGuides() {
    finished = true;
    window.clearTimeout(showTimer);
    window.clearTimeout(hideTimer);
    getGuides().forEach((guide) => {
      guide.classList.remove(ACTIVE_CLASS);
      guide.classList.add(FINISHED_CLASS);
      guide.setAttribute('aria-hidden', 'true');
    });
  }

  function startGuides() {
    const cards = getCards();
    const guides = getGuides(cards);
    if (
      started ||
      finished ||
      cards.length !== TARGET_SELECTORS.length ||
      guides.length !== TARGET_SELECTORS.length
    ) return;

    started = true;
    showTimer = window.setTimeout(() => {
      if (finished) return;
      guides.forEach((guide) => {
        guide.classList.remove(FINISHED_CLASS);
        guide.classList.add(ACTIVE_CLASS);
        guide.setAttribute('aria-hidden', 'false');
      });
      hideTimer = window.setTimeout(hideGuides, FINISH_DELAY_MS);
    }, START_DELAY_MS);
  }

  function bindDismissal(card) {
    if (boundCards.has(card)) return;
    boundCards.add(card);

    card.addEventListener('pointerdown', (event) => {
      if (event.target.closest(SIZE_OPTION_SELECTOR)) hideGuides();
    }, { passive: true });
    card.addEventListener('keydown', (event) => {
      if (
        (event.key === 'Enter' || event.key === ' ') &&
        event.target.closest(SIZE_OPTION_SELECTOR)
      ) hideGuides();
    });
  }

  function initialize() {
    const cards = getCards();
    if (cards.length !== TARGET_SELECTORS.length) return;
    cards.forEach(bindDismissal);
    if (started || finished) return;

    if ('IntersectionObserver' in window) {
      if (observer) observer.disconnect();
      const trigger = cards[0].closest('[data-cloth-product-rows]') || cards[0];
      observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        startGuides();
      }, { rootMargin: '0px', threshold: 0.2 });
      observer.observe(trigger);
      return;
    }

    startGuides();
  }

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState !== 'loading') initialize();
})();
